import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "../../../components";
import { BookStore, LibraryStore, Dispatcher } from "../../../flux";

export default class BookUnavailable extends React.Component {
  constructor(props) {
    super(props);
    this.setupRedemptionModal = this.setupRedemptionModal.bind(this);
  }

  setupRedemptionModal(event) {
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "redeem-code");
  }

  render() {
    let url = Fraction.Brand.Store.url;
    if (url && url.indexOf("vitalsource.") >= 0) {
      // Only our specific vitalsource store is gonna support this query term thing...
      // This should cover vitalsource.com vitalsource.co.uk etc
      url = Fraction.Helpers.Locations.addParameter(
        Fraction.Brand.Store.url,
        "term",
        this.props.book.isbn
      );
    }
    if (this.props.book) {
      return (
        <div>
          <div id="book-unavailable">
            <p>{i18n.t("book-unavailable.purchase-book")}</p>
            <img
              src={LibraryStore.get()
                .coverURL.replace(":width", "120")
                .replace(":isbn", this.props.book.isbn)}
            />
            <div id="book-details">
              <p id="unavailable-title">{this.props.book.title}</p>
              <p id="unavailable-author">{this.props.book.author}</p>
              <p id="unavailable-isbn">VBID: {this.props.book.isbn}</p>
            </div>
            <div id="unavailable-buttons">
              <a
                id="unavailable-redeem"
                onClick={this.setupRedemptionModal}
                className="submit"
              >
                {i18n.t("book-unavailable.redeem")}
              </a>
              <a
                href={url}
                target="_blank"
                id="unavailable-buy"
                className="submit"
              >
                {i18n.t("book-unavailable.buy")}
              </a>
            </div>
          </div>
          <div id="unavailable-buttons">
            <a
              id="unavailable-redeem"
              onClick={e => {
                this._redeem(e);
              }}
              className="submit"
            >
              {i18n.t("book-unavailable.redeem")}
            </a>
            <a
              href={url}
              target="_blank"
              id="unavailable-buy"
              className="submit"
            >
              {i18n.t("book-unavailable.buy")}
            </a>
          </div>
        </div>
      );
    }
    return <Spinner />;
  }
}

BookUnavailable.propTypes = {
  isbn: PropTypes.string.isRequired
};

// module.exports removed — already using export default above
